module.exports = __webpack_public_path__ + "img/chr_ts_5.774b3ba6.png";